import { toDateInputValue } from "../utils/holdingsPeriod";
const HoldingsFilters = ({
  reportDate,
  onReportDateChange,
  maxReportDate,
  reportClassifications,
  selectedReportClassification,
  onReportClassificationChange,
  views,
  selectedView,
  onViewChange,
  hideZero,
  onHideZeroChange,
  onGo,
  showAdvancedControls = false,
  additionalControls = null,
}) => {
  const toIsoDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) return "";
    return date.toISOString().slice(0, 10);
  };

  const findById = (list, id, camel, pascal) =>
    (list || []).find((item) => String(item?.[camel] ?? item?.[pascal]) === String(id)) || null;

  return (
    <section className="col-md-12 login-form holdings-filter-bar">
      <div className="action-bar custom-fonts">
        <div className="row">
          <form className="col-md-12 for-font-size holdings-filter-form" onSubmit={(e) => e.preventDefault()}>
            {additionalControls}

            <div className="holdings-date-wrap" style={{position:"relative"}}>
              <label className="control-label custom-fonts holdings-label">Date:</label>
              {/* <input
                type="date"
                className="form-control holdings-native-input"
                value={toIsoDate(reportDate)}
                onChange={(e) => onReportDateChange(e.target.value ? new Date(e.target.value) : null)}
              /> */}
              <input
  type="date"
  className="form-control holdings-native-input"
  value={toDateInputValue(reportDate)}
  max={toDateInputValue(maxReportDate)}
  onChange={(event) => {
    if (!event.target.value) return;
    onReportDateChange(new Date(`${event.target.value}T00:00:00`));
  }}
/>
            </div>

            <div style={{display:"none"}}>
              <label className="control-label custom-fonts holdings-label">Report Classification:</label>
              <select
                className="form-control holdings-native-select"
                value={selectedReportClassification?.ReportClassificationId ?? selectedReportClassification?.reportClassificationId ?? ""}
                onChange={(e) =>
                  onReportClassificationChange(
                    findById(
                      reportClassifications,
                      e.target.value,
                      "reportClassificationId",
                      "ReportClassificationId"
                    )
                  )
                }
              >
                {(reportClassifications || []).map((item) => {
                  const id = item?.reportClassificationId ?? item?.ReportClassificationId;
                  const name = item?.reportClassification ?? item?.ReportClassification;
                  return (
                    <option key={id} value={id}>
                      {name}
                    </option>
                  );
                })}
              </select>
            </div>

            <div style={{display:"none"}}>
              <label className="control-label custom-fonts holdings-label">View:</label>
              <select
                className="form-control holdings-native-select"
                value={selectedView?.ViewID ?? selectedView?.viewID ?? ""}
                onChange={(e) =>
                  onViewChange(findById(views, e.target.value, "viewID", "ViewID"))
                }
                disabled={!showAdvancedControls}
              >
                {(views || []).map((item) => {
                  const id = item?.viewID ?? item?.ViewID;
                  const name = item?.viewName ?? item?.ViewName;
                  return (
                    <option key={id} value={id}>
                      {name}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className={``} style={{display:"none"}}>
              <label className="custom-fonts holdings-hide-zero-label">
                <input
                  type="checkbox"
                  checked={hideZero}
                  onChange={(e) => onHideZeroChange(e.target.checked)}
                  style={{ marginRight: 6 }}
                />
                Hide Zero
              </label>
            </div>

            <div className="holdings-go-wrap">
              <button
                type="button"
                className="btn2 btn-block focus-remove custom-fonts"
                onClick={onGo}
              >
                Go
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default HoldingsFilters;
